"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BinaryMessage = void 0;
class BinaryMessage {
    constructor(payload) {
        this.payload = payload;
    }
    writeTo(cell) {
        cell.bits.writeBuffer(this.payload);
    }
}
exports.BinaryMessage = BinaryMessage;
